import React, { FC, Fragment } from 'react';
import { Box, Grid } from '@mui/material';
import TopBarOrderStatusSection from 'components/order-details/main-order-view/top-bar-order-status-section/top-bar-order-status-section.component';
import TopBarOperationSection from 'components/order-details/main-order-view/top-bar-operation-section/top-bar-operation-section.component';
import { Order } from 'models/order';
import { permissions } from 'utils/permission';
import { currentUserVar } from 'apollo/reactive-variables/user';
import LabFlagButton from 'components/shared/lab-flag-button/lab-flag-button.component';
import { isSupplier } from 'utils/client-settings';
import { currentOrgVar } from 'apollo/reactive-variables/organization';

type OrderDetailsTopBarProps = {
    currency: string;
    order: Order;
    onHandleDeliveryNoteCreation: () => void;
};
const OrderDetailsTopBar: FC<OrderDetailsTopBarProps> = ({
    currency,
    order,
    onHandleDeliveryNoteCreation,
}: OrderDetailsTopBarProps) => {
    const currentUser = currentUserVar();
    const currentOrganization = currentOrgVar();

    return (
        <Fragment>
            <Box>
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs={12} md={4}>
                        {(!permissions.isExternalTechnician(currentUser.role) ||
                            permissions.isElevatedExternalUser(currentUser.role)) &&
                        !order.isImportedOrder ? (
                            <TopBarOrderStatusSection
                                order={order}
                                onHandleDeliveryNoteCreation={onHandleDeliveryNoteCreation}
                            />
                        ) : undefined}
                    </Grid>
                    <Grid item xs={0} md={8} sx={{ display: { xs: 'none', md: 'block' } }}>
                        <Box display="flex" alignItems="center" justifyContent="flex-end">
                            <TopBarOperationSection
                                currency={currency}
                                order={order}
                                onHandleDeliveryNoteCreation={onHandleDeliveryNoteCreation}
                            />
                            {isSupplier(currentOrganization._id, order.supplier._id) && !order.isImportedOrder ? (
                                <LabFlagButton order={order} />
                            ) : undefined}
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Fragment>
    );
};

export default OrderDetailsTopBar;
